import { useTranslation } from "react-i18next";

const CameraHeader = ({ onSort, sortByField, orderSortByField }) => {
  const { t } = useTranslation();

  const handleSort = (field) => {
    if (onSort) {
      // Si on clique sur la même colonne, on alterne l'ordre
      if (sortByField === field) {
        onSort(field, orderSortByField === "1" ? "-1" : "1");
      } else {
        // Sinon, on trie par défaut en croissant
        onSort(field, "1");
      }
    }
  };

  const getSortIcon = (field) => {
    if (sortByField === field) {
      // Affiche la flèche correspondant à l'ordre actuel
      return orderSortByField === "1" ? "fa-sort-up" : "fa-sort-down";
    }
    // Par défaut, affiche les deux flèches superposées
    return "fa-sort";
  };

  return (
    <article className="table-standard-header">
      <div
        className="table-standard-header-cell"
        style={{ cursor: "pointer" }}
        onClick={() => handleSort("name")}
      >
        {t("ID")}
        <span className="sort-icon">
          <i className={`fas ${getSortIcon("name")}`}></i>
        </span>
      </div>
      <div
        className="table-standard-header-cell"
        style={{ cursor: "pointer" }}
        onClick={() => handleSort("lastScanDate")}
      >
        {t("Last image")}
        <span className="sort-icon">
          <i className={`fas ${getSortIcon("lastScanDate")}`}></i>
        </span>
      </div>
      <div className="table-standard-header-cell">{t("Address")}</div>
      <div
        className="table-standard-header-cell"
        style={{ cursor: "pointer" }}
        onClick={() => handleSort("batteryLevel")}
      >
        {t("Battery")}
        <span className="sort-icon">
          <i className={`fas ${getSortIcon("batteryLevel")}`}></i>
        </span>
      </div>
    </article>
  );
};

export default CameraHeader;
